export var getScheduleTbdMessage = function (event) {
    try {
        if (event.scheduling.config.scheduleTbd) {
            return event.scheduling.config.scheduleTbdMessage || 'TBD';
        }
    }
    catch (e) {
        return;
    }
};
export var getStartDate = function (event) {
    try {
        if (event.scheduling.config.startDate) {
            return new Date(event.scheduling.config.startDate);
        }
    }
    catch (e) {
        return;
    }
};
export function getStartDateString(event, format) {
    if (!format) {
        return event.scheduling.formatted;
    }
    var startDate = getStartDate(event);
    if (startDate) {
        return getLocaleDateString(startDate, format);
    }
    return getScheduleTbdMessage(event);
}
export function getLocaleDateString(date, format) {
    if (format === void 0) { format = {}; }
    var locales = format.locales, options = format.options, hideCurrentYear = format.hideCurrentYear;
    var isCurrentYear = new Date().getFullYear() === date.getFullYear();
    if (hideCurrentYear && options && isCurrentYear) {
        format.options.year = undefined;
    }
    return date.toLocaleDateString(locales || [], options);
}
//# sourceMappingURL=scheduling.js.map